import * as z from 'zod/v4';

export const BET_PROPS = ['XPERTEN', 'GROUP', 'GROUP_B2C', 'COMPETITION', 'REDUCERA_FRITT', 'EGNARADER'] as const;

export const betPropsEnum = z.enum(BET_PROPS);

export type BetProp = z.infer<typeof betPropsEnum>;
